/**
 * lumi-cro.js
 * Conversion-rate optimisation helpers for Lumi & Co product pages.
 *
 * Modules:
 *   1. Viewing counter  — randomised live-demand signal above the ATC button
 *   2. Delivery estimator — "Order in Xh Ym for same-day dispatch" urgency strip
 *   3. Sticky ATC bar — fixed bottom bar that appears when the main button scrolls off-screen
 */
(function () {
  'use strict';

  /* ── 1. Viewing Counter ─────────────────────────────────────────────────── */
  function initViewingCounter() {
    var els = document.querySelectorAll('[id^="lumi-viewing-"]');
    if (!els.length) return;

    els.forEach(function (el) {
      var base = 12 + Math.floor(Math.random() * 22); // 12–33
      el.textContent = base;

      setInterval(function () {
        var current = parseInt(el.textContent, 10);
        var r = Math.random();
        var delta = r > 0.62 ? 1 : r > 0.82 ? -1 : 0;
        var next = Math.max(8, Math.min(44, current + delta));
        if (next !== current) el.textContent = next;
      }, 9000 + Math.floor(Math.random() * 6000));
    });
  }

  /* ── 2. Delivery Estimator ──────────────────────────────────────────────── */
  function initDeliveryEstimator() {
    var els = document.querySelectorAll('.lumi-delivery-est');
    if (!els.length) return;

    var now = new Date();
    var h = now.getHours();
    var m = now.getMinutes();
    var msg = '';

    if (h < 15) {
      // Before 3 pm — show countdown to cut-off
      var hLeft = 14 - h;
      var mLeft = 60 - m;
      if (mLeft === 60) { mLeft = 0; hLeft += 1; }
      var timeStr = hLeft > 0
        ? (hLeft + 'h ' + mLeft + 'm')
        : (mLeft + 'm');
      msg = '&#9889; Order in <strong>' + timeStr + '</strong> for <strong>same-day dispatch</strong>';
    } else if (h < 20) {
      // 3 pm – 8 pm
      msg = '&#128230; Order now for <strong>next business day dispatch</strong>';
    } else {
      return; // after 8 pm — nothing shown, avoids negative messaging
    }

    els.forEach(function (el) {
      el.innerHTML = msg;
      el.removeAttribute('hidden');
    });
  }

  /* ── 3. Sticky ATC Bar ──────────────────────────────────────────────────── */
  function initStickyATC() {
    var bars = document.querySelectorAll('[id^="lumi-sticky-atc-"]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var sectionId = bar.dataset.section;
      if (!sectionId) return;

      var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!mainBtn) return;

      var mainWrapper = mainBtn.closest('.product-form__buttons');
      if (!mainWrapper) return;

      /* Show bar when the main ATC button scrolls out of view */
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('lumi-sticky-atc--visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('lumi-sticky-atc--visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -40px 0px' }
      );

      observer.observe(mainWrapper);

      /* Wire sticky button — triggers the real form submit */
      var stickyBtn = bar.querySelector('[data-target-btn]');
      if (!stickyBtn) return;

      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) {
          /* Sold out / unavailable — scroll user to the variant selector */
          mainWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainBtn.click();
      });

      /* Sync disabled state from the real button to the sticky button */
      var syncDisabled = function () {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.querySelector('span')
          ? mainBtn.querySelector('span').textContent
          : mainBtn.textContent;
      };

      /* Observe real button attribute changes (variant switches update disabled) */
      var mutObs = new MutationObserver(syncDisabled);
      mutObs.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      syncDisabled(); // initial sync
    });
  }

  /* ── Init ───────────────────────────────────────────────────────────────── */
  function init() {
    initViewingCounter();
    initDeliveryEstimator();
    initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
